import { RpcException } from "@/core/rpc-mp-provider/exceptions/RpcException.ts";
import { RpcNotFoundException } from "@/core/rpc-mp-provider/exceptions/RpcNotFoundException.ts";

export class RpcMpProviderFailedResponse {
  public status: boolean;

  public message: string;

  public error: Error;

  protected isNotFoundError: boolean;

  constructor(error: Error | string | { message: string }) {
    this.status = false;
    if (typeof error === "string") {
      this.message = error;
      this.error = new Error(error);
      this.isNotFoundError = /^PROCEDURE_NOT_FOUND /.test(error);
    }

    if (error instanceof Error) {
      this.message = error.message || "unknown rpc error";
      this.error = error;
    }

    if (
      this.error === undefined &&
      typeof error === "object" &&
      "message" in error &&
      typeof error.message === "string"
    ) {
      this.message = error.message;
      this.error = new Error(error.message);
    }

    if (this.error === undefined) {
      this.message = "Unknown Error";
      this.error = new Error("Unknown Error");
    }
  }

  public unwrapOrThrow(): never {
    this.makeItProlapsed();
  }

  public throwIfFailed(): never {
    this.makeItProlapsed();
  }

  protected makeItProlapsed(): never {
    if (this.isNotFoundError) {
      throw new RpcNotFoundException(this.error);
    }

    throw new RpcException(this.error);
  }
}
